module.exports = __webpack_public_path__ + "static/media/sjulsmark.37f3f76d.jpg";